import { graphql, HttpResponse } from 'msw'
import {
  type InvestmentTransferValidation,
  type InvestmentTransferValidationError,
  InvestmentTransferValidationErrorType,
} from '../../../models/transactions/transactions'

export const investmentTransferValidationMock: InvestmentTransferValidation = {
  __typename: 'InvestmentTransferValidation',
  _: true,
}

export const investmentTransferValidationErrorMock: InvestmentTransferValidationError = {
  __typename: 'InvestmentTransferValidationError',
  errorType: InvestmentTransferValidationErrorType.PENDING_TRANSFER_ALREADY_EXISTS,
}

export const mockGetInvestmentTransferValidationHandler = graphql.query('investmentTransferValidation', () => {
  return HttpResponse.json({ data: { investmentTransferValidation: investmentTransferValidationMock } })
})

export const mockBankInvestmentTransfers = [mockGetInvestmentTransferValidationHandler]
